<template>
  <div class="modern-product-card" @click="toDetail(obj.id, type)">
      <div class="image-container">
          <el-image class="product-image" :src="obj.image || ''" fit="cover" lazy>
              <div slot="placeholder" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
              </div>
          </el-image>
          <div class="product-badge" v-if="obj.otPrice > obj.price">Sale</div>
      </div>
      
      <div class="product-info">
          <h4 class="product-title">{{ obj.storeName }}</h4>
          <div class="product-footer">
              <div class="price-group">
                  <span class="current-price">¥{{ obj.price || obj.otPrice }}</span>
                  <span class="original-price" v-if="obj.otPrice > obj.price">¥{{ obj.otPrice }}</span>
              </div>
              <div class="cart-action-btn" @click.stop="toDetail(obj.id, type)">
                  <i class="el-icon-shopping-cart-2"></i>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'ProductItem',
    props: {
        obj: Object,
        type: Number
    },
    methods: {
        toDetail (id, type) {
            this.$router.push({
                path: '/productDetail',
                query: {
                    productId: id,
                    type: type
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.modern-product-card {
    background: $white;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid $gray-100;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
        border-color: rgba($primary-color, 0.3);

        .image-container .product-image {
            transform: scale(1.05);
        }
        
        .cart-action-btn {
            background: $primary-color;
            color: $white;
        }
    }

    .image-container {
        position: relative;
        height: 240px;
        overflow: hidden;
        background: $gray-50;

        .product-image {
            width: 100%;
            height: 100%;
            transition: transform 0.6s ease;
        }

        .product-badge {
            position: absolute;
            top: 12px;
            left: 12px;
            background: $primary-color;
            color: $white;
            font-size: 11px;
            font-weight: 800;
            padding: 4px 10px;
            border-radius: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            box-shadow: 0 4px 8px rgba($primary-color, 0.3);
        }

        .image-slot {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            color: $gray-200;
            font-size: 30px;
        }
    }

    .product-info {
        padding: 16px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .product-title {
            font-size: 14px;
            color: $gray-900;
            font-weight: 700;
            line-height: 1.5;
            margin-bottom: 12px;
            height: 42px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .product-footer {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .price-group {
                display: flex;
                flex-direction: column;
                .current-price {
                    font-size: 20px;
                    font-weight: 800;
                    color: $gray-900;
                }
                .original-price {
                    font-size: 13px;
                    color: $gray-400;
                    text-decoration: line-through;
                    margin-top: 2px;
                }
            }

            .cart-action-btn {
                width: 36px;
                height: 36px;
                border-radius: 12px;
                background: $gray-50;
                color: $gray-400;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: all 0.3s ease;
                font-size: 18px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/indexItem.vue